import React from 'react';
import Article from '../../components/Article';
import { useGetArticleQuery } from '../../redux/services/blog/ArticleAPI';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

function Articles() {
  const { data: articles, isError, error, isLoading } = useGetArticleQuery();

  if (isLoading) {
    return (
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
    );
  }

  if (isError) {
    return <div className="section-shell py-24 text-center text-red-500">Error: {error?.data?.message || error?.message}</div>;
  }

  return (
    <section className="bg-surface py-20">
      <div className="section-shell">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <span className="eyebrow">Journal</span>
          <h1 className="section-title mt-5">Travel stories and booking insights</h1>
          <p className="section-copy mx-auto">Editorial content that helps guests plan better stays, better meals, and better trips.</p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {(articles || []).map((article) => (
            <Article key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Articles;
